export default __webpack_public_path__ + "static/media/blogs_img.22b29d76.png";